import api from './api';
export const contactApi = {
  sendEmail: async (form, attachments = [], config = {}) => {
    if (!attachments.length) return (await api.postPublic('/contact', form, config)).data;
    const body = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (value !== undefined) body.append(key, value);
    });
    attachments.forEach((file) => body.append('attachments', file, file.name));
    return (await api.postPublic('/contact/with-attachments', body, config)).data;
  },
};
